<template>
  <div v-if="summaryData">
    <a-row type="flex">
      <a-col style="text-align: center;border-right: 1px solid #e8e8e8;">
       <a-row type="flex">
        <a-col flex="64px" align="left">
            <a-avatar :size="64" icon="user"></a-avatar>
        </a-col>
        <a-col align="left" style="margin:0 20px;">
          <div>
            <div style="font-weight: 700;font-size:1.1rem;margin:5px 0 9px 0;color:#000000b8;">
              <span v-if="summaryData.titleDict">{{ summaryData.titleDict.enName }} </span>
              <span>{{ summaryData.fullName }}</span>
            </div>
            <!--customerCode  -->
            <div v-if="summaryData.customerCode && summaryData.customerCode !== '' ">
             <strong>No. </strong><span style="font-weight: 500;">{{ summaryData.customerCode }}</span>
            </div>
          </div>
        </a-col>
       </a-row>
      </a-col> 
      <!-- right -->
      <a-col class="summary-right" flex="1" justify="center" style="">
        <span>
          <h4>Membership:</h4>
          <span class="men-no" v-if="summaryData.membership">
            <router-link target="_blank" :to="{ name: 'EditMembershipPage', params: { membershipIdOrCode: summaryData.membership.membershipCode }}">{{ summaryData.membership.membershipCode }}</router-link>
          </span>
          <span class="men-no" v-else> No</span>
        </span>
        <!--companyCode  -->
        <span v-if="summaryData.companyCode && summaryData.companyCode !== '' ">
          <h4>Company:</h4>{{ summaryData.companyCode }}
        </span>
        <!--dob  -->
        <span v-if="summaryData.birthday && summaryData.birthday !== '' ">
          <h4><icon-font type="icon-shengrix" /></h4>{{ dateFormatB(summaryData.birthday) }}
        </span>
        <!--email  -->
        <span v-if="summaryData.email && summaryData.email !== '' ">
          <h4>E-Mail:</h4>{{ summaryData.email }}
        </span>
        <!--phone  -->
        <span v-if="summaryData.phoneNumber && summaryData.phoneNumber !== '' ">
          <h4><icon-font type="icon-dianhua2" /></h4>+{{ summaryData.phoneCountryCallingCode }} {{ summaryData.phoneNumber }}
          <span v-if="summaryData.phoneExt && summaryData.phoneExt !== '' " style="color:#999;">Ext.{{ summaryData.phoneExt }}</span>
        </span>
        <!--languages  -->
        <span v-if="summaryData.languagesName"><h4 style="margin-right: 8px;">Primary Language:</h4>
          <span>
            {{ summaryData.languagesName }}
          </span>
        </span>
        <!--Background  -->
        <span v-if="summaryData.nationalBackgroundName"><h4 style="margin-right: 5px;">Origin:</h4>
          <span> 
            {{ summaryData.nationalBackgroundName }}
          </span>
        </span>
      </a-col>
    </a-row>
    <a-divider style="margin:20px 0;" dashed />
  </div>
</template>

<script>
import { Title } from '@/utils/helper/standard-code-utils'
import { Language, Background } from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'CdbCustomerSummary',
  components: {
  },
  props: {
    initData: {
      type: [Object],
      default: null
    },
    countryList: {
      type: [Array],
      default: null
    }
  },
  data () {
    return {
      summaryData: null,
      // backgroundList: NationalBackground.dict,
    }
  },
  mounted () {
    this.loadData ()
  },
  methods: {
    async loadData () {
      this.summaryData = null
      const summaryData = this.copyDataByJSON(this.initData)
      if (summaryData) {
        // 客人Title
        let title = summaryData.title
        if (title && title !== '') {
          title = Title.getByCode(title)
          summaryData.titleDict = title
        }
        // 客人语言字符串转换数组
        const languages = summaryData.languages
        if (languages && languages !== '') {
          summaryData.languagesName = await Language.getByCode(languages)
          summaryData.languagesName = summaryData.languagesName.enName
        } else {
          summaryData.languagesName = null
        }
        
        // 客人背景国籍字符串转换数组
        const backgrounds = summaryData.nationalBackground
        if (backgrounds && backgrounds !== '') {
          summaryData.nationalBackgroundName = await Background.getByCode(backgrounds)
          // console.log('summaryData.nationalBackgroundName', summaryData.nationalBackgroundName)
          summaryData.nationalBackgroundName = summaryData.nationalBackgroundName.enName
        } else {
          summaryData.nationalBackgroundName = null
        }
      }
      this.summaryData = summaryData
    },
    getCountryById (countryId) {
      if (this.countryList && this.countryList.length > 0) {
        const fs = this.countryList.filter(c => {
          return c.id == countryId
        })
        if (fs && fs.length > 0) {
          return fs[0]
        }
      }
      return null
    },
    // 添加 /线
    getLanguageById (languageId) {
        const fs = this.languageList.filter(c => {
          return c.id == languageId
        })
        if (fs && fs.length > 0) {
          return fs[0]
        }
      return null
    },
  },
  watch: {
    initData (val) {
      this.summaryData = this.copyDataByJSON(val)
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
.ant-divider-horizontal {
  margin: 10px 0;
}
.summary-right {
  margin:5px  0 0 20px;
  font-size: 1rem;
}
.summary-right span {
  margin-right:30px;
  display: inline-block;
}
.summary-right span > h4{
  display: inline-block;
  margin-right: 8px;
}
.summary-right a {
  text-decoration:underline;
}
.men-no {
  margin: 0 !important;
}
</style>
